import { render, staticRenderFns } from "./shoppingCartSetting.vue?vue&type=template&id=49236e5d"
import script from "./shoppingCartSetting.vue?vue&type=script&lang=js"
export * from "./shoppingCartSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports